export default class ContactForm {
    constructor() {
        const form = document.querySelector('.w-b-contact-form');

        if (form) {
            const input = form.querySelector('#frm_message');

            form.addEventListener('submit', (e) => {
                if (!form.classList.contains('w-is-active')) {
                    form.classList.add('w-is-active');
                }
            });

            input.addEventListener('keyup', function (e) {
                if (this.value !== '') {
                    form.classList.add('w-is-active');
                } else {
                    form.classList.remove('w-is-active');
                }
            });
        }
    }
}
